var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0003 2.95442C20.1734 2.78318 19.3138 2.69287 18.4314 2.69287C11.9123 2.69287 6.6355 7.62229 6.6355 13.7006C6.6355 14.0479 6.64887 14.3819 6.68895 14.7159C7.87789 13.9411 9.30728 13.5003 10.8569 13.5003C14.918 13.5003 18.2043 16.5727 18.2043 20.3667C18.2043 21.9564 17.6165 23.4259 16.628 24.5881C17.2158 24.6683 17.8169 24.7083 18.4314 24.7083L24.0288 28.0347C24.9773 28.6091 26.1662 27.8343 26.0326 26.7255L25.5116 22.5041C28.3704 20.5003 30.4352 17.5952 30.2273 13.7006C30.2025 13.2348 30.0898 12.514 30.0898 12.514",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5002 10.3701C29.9855 10.3701 32.0002 8.3554 32.0002 5.87012C32.0002 3.38484 29.9855 1.37012 27.5002 1.37012C25.015 1.37012 23.0002 3.38484 23.0002 5.87012C23.0002 8.3554 25.015 10.3701 27.5002 10.3701Z",
    fill: "#828ECC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2063 20.3667C18.2063 21.9564 17.6185 23.4259 16.6299 24.5881C15.3074 26.1912 13.21 27.2198 10.8589 27.2198L7.37219 29.2904C6.7844 29.6511 6.0363 29.1568 6.11646 28.4755L6.45043 25.8439C4.66034 24.6015 3.51147 22.6109 3.51147 20.3667C3.51147 18.0155 4.76722 15.9449 6.6909 14.7159C7.87984 13.9411 9.30924 13.5002 10.8589 13.5002C14.92 13.5002 18.2063 16.5727 18.2063 20.3667Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationChat);
export default __webpack_public_path__ + "static/media/notification-chat.8120ad0c.svg";
export { ForwardRef as ReactComponent };